import React, { Component } from "react";
import { YMaps, Map, Placemark, Clusterer } from "react-yandex-maps";
import { withWrapper } from "create-react-server/wrapper";

import "./AfishaMap.css";

class AfishaMap extends Component {
  state = {
    center: [55.76, 37.62],
    height: "500px",
    zoom: 9
  };

  componentWillUpdate(nextProps) {
    if (!nextProps.isBalloonSelected && this.props.isBalloonSelected) {
      this.setState({
        center: [55.76, 37.62],
        zoom: 9
      });
    }

    if (this.refs.ymaps) this.refs.ymaps.className = "map_show";
  }

  addDecay = ymaps => {
    if (ymaps) ymaps.behaviors.disable("scrollZoom");
  };

  getPointData = index => {
    return {
      hintContent: `<p>${index}</p>`
    };
  };

  getPointOptions = style => {
    return {
      preset: "islands#Icon",
      iconColor: style
    };
  };

  handleBalloonClick = (id, coordinates) => {
    this.setState({
      center: coordinates,
      zoom: 17
    });

    this.props.renderBalloonEventCards(id);
  };

  render() {
    const { center, zoom, height } = this.state;
    const { balloonId, libraries } = this.props;

    return (
      <div ref="ymaps" className="ymaps-container content">
        <YMaps>
          <Map
            width="100%"
            height={height}
            state={{ center: center, zoom: zoom, controls: ["zoomControl"] }}
            options={{ suppressMapOpenBlock: true }}
            instanceRef={ymaps => this.addDecay(ymaps)}
          >
            <Clusterer
              options={{
                gridSize: 32,
                preset: "islands#blueClusterIcons",
                groupByCoordinates: false,
                clusterDisableClickZoom: false,
                clusterHideIconOnBalloonOpen: false,
                geoObjectHideIconOnBalloonOpen: false
              }}
            >
              {libraries.map((library, i) => {
                const {
                  id,
                  style,
                  geometry: { coordinates },
                  properties: { hintContent }
                } = library;

                return (
                  <Placemark
                    key={i}
                    geometry={{ coordinates }}
                    options={this.getPointOptions(style)}
                    properties={this.getPointData(hintContent)}
                    onClick={() =>
                      balloonId !== id &&
                      this.handleBalloonClick(id, coordinates)
                    }
                  />
                );
              })}
            </Clusterer>
          </Map>
        </YMaps>
      </div>
    );
  }
}

export default withWrapper(AfishaMap);



// WEBPACK FOOTER //
// ./src/components/Events/AfishaMap.js